import { PortalColorSchemas, ThemeColorSchemas } from '@nx-frontend/shared/types';
import { getFixedImageUrl } from '@nx-frontend/shared/utils';

export type LogoImages = {
  schema: PortalColorSchemas;
  src: string;
}[];

interface GetLogoImagesProps {
  footer?: boolean;
}

/**
 * Get logo images for the given theme colors
 * @param themeColors - Theme colors
 * @param footer - Whether to get footer logo images
 * @returns Logo images
 */
export function getLogoImages(themeColors: ThemeColorSchemas, { footer = false }: GetLogoImagesProps = {}): LogoImages {
  return themeColors.reduce((classNames, { schema, colors }) => {
    const { logo } = colors;
    const imageObj = typeof logo === 'string' ? { url: logo } : footer && logo.footer != null ? logo.footer : logo.main;
    classNames.push({
      schema,
      src: getFixedImageUrl(imageObj.url),
    });
    return classNames;
  }, [] as LogoImages);
}
